<script setup>
import { storeToRefs } from 'pinia'
import History from 'assets/icons/history.svg'
// import Locator from 'assets/icons/locator.svg'
//  import Info from 'assets/icons/info.svg'
import { computed } from 'vue'
import { useMessageStore } from '~/stores/messages'

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Fetch route
// const route = useRoute()
// const centerRoute = computed(() => route.params?.centerUid)

// Fetch Center Details
// const { data: centerDetails, suspense: centerDetailSuspense } = useFetchCenterDetails(centerRoute.value)

/*
onServerPrefetch(async () => {
    await centerDetailSuspense()
})
*/

// Define info boxes
const parkingOverviewInfoBoxes = computed(() => {
    return [
        {
            headlineConfig: {
                headline: {
                    title: staticKeys.value?.parkingfirstpage_history_headline
                },
                icon: {
                    name: History
                }
            },
            description: staticKeys.value?.parkingfirstpage_history_abstract,
            ctaLabel: staticKeys.value?.parkingfirstpage_history_cta,
            buttonConfig: {
                buttonType: 'secondary',
                type: 'internal',
                link: 'centerUid-parking-payment-history',
                large: true,
                active: true,
                fn: () => trackUserClick({
                    eventName: TRACKING_CONSTANTS.CLICK_EVENTS.PARKING_HOME_CLICK,
                    button: TRACKING_CONSTANTS.MISC.PARKING_HISTORY
                })
            }
        }
        /*
        {
            headlineConfig: {
                headline: {
                    title: staticKeys.value?.parkingfirstpage_faq_headline
                },
                icon: {
                    name: Info
                }
            },
            description: staticKeys.value?.parkingfirstpage_faq_copytext,
            ctaLabel: staticKeys.value?.parkingfirstpage_faq_cta,
            buttonConfig: {
                buttonType: 'secondary',
                type: 'internal',
                link: 'centerUid-faq',
                large: true,
                active: true,
                fn: () => trackUserClick({
                    eventName: TRACKING_CONSTANTS.CLICK_EVENTS.PARKING_HOME_CLICK,
                   button: TRACKING_CONSTANTS.MISC.FAQ
                })
            }
        },

        {
            headlineConfig: {
                headline: {
                    title: centerDetails.value?.centerName
                },
                icon: {
                    name: Locator
                }
            },
            description: staticKeys.value?.parkingfirstpage_centerinfo_teaser,
            ctaLabel: staticKeys.value?.parkingfirstpage_centerinfo_cta,
            buttonConfig: {
                buttonType: 'secondary',
                type: 'internal',
                link: 'centerUid',
                large: true,
                active: true,
                fn: () => trackUserClick({
                    eventName: TRACKING_CONSTANTS.CLICK_EVENTS.PARKING_HOME_CLICK,
                   button: TRACKING_CONSTANTS.MISC.INFOS
                })
            }
        }
         */
    ]
})
</script>

<template>
    <ContentHeadline :content-headline-config="{ title: staticKeys?.parkingfirstpage_moreinfo_headline_web_markdown, renderSplit: true }" />

    <DefaultContentBoxList>
        <DefaultContentBox v-for="(parkingOverviewInfoBox, index) in parkingOverviewInfoBoxes" :key="`parking-info-box-${index}`">
            <header class="parking-info-box-header">
                <DefaultContentBoxHeadline :content-box-headline-config="parkingOverviewInfoBox.headlineConfig" />

                <p class="parking-info-box-description">
                    {{ parkingOverviewInfoBox.description }}
                </p>
            </header>

            <footer class="parking-info-box-footer">
                <BaseButton :base-button-config="parkingOverviewInfoBox.buttonConfig">
                    {{ parkingOverviewInfoBox.ctaLabel }}
                </BaseButton>
            </footer>
        </DefaultContentBox>
    </DefaultContentBoxList>
</template>

<style lang="scss">
.parking-info-box-header {
    width: 100%;
}

.parking-info-box-description {
    padding: 0;
    margin-block: 0 px2rem(30);

    @include body1-medium;

    @include bp(medium1) {
        margin-block-end:  px2rem(50);
    }
}

.parking-info-box-footer {
    margin-top: auto;
    width: 100%;
}
</style>
